import { useMemo } from 'react';
import { IconName } from '../../Icon.types';
import * as Icon from '../../assests';
export const useIcon = (name) => {
    const icon = useMemo(() => {
        const icon = {
            [IconName.LOCATION]: Icon.Location,
            [IconName.ADD]: Icon.Add,
            [IconName.BAN]: Icon.Ban,
            [IconName.BRIEFCASE]: Icon.Briefcase,
            [IconName.BUSINESS]: Icon.Business,
            [IconName.CALENDAR]: Icon.Calendar,
            [IconName.MULTIPLY]: Icon.Multiply,
            [IconName.REMOVE]: Icon.Remove,
            [IconName.USERS]: Icon.Users,
            [IconName.CHECK]: Icon.Check,
            [IconName.SPINNER]: Icon.Spinner,
            [IconName.BILLS]: Icon.Bills,
            [IconName.VERIFIED_FILL]: Icon.VerifiedFill,
            [IconName.SITEMAP]: Icon.Sitemap,
            [IconName.SLIDERS]: Icon.Sliders,
            [IconName.SHIELD]: Icon.Shield,
            [IconName.CARET_DOWN]: Icon.CaretDown,
            [IconName.CIRCLE_QUESTION]: Icon.CircleQuestion,
            [IconName.CHEVRON_DOWN]: Icon.ChevronDown,
            [IconName.TRASH]: Icon.Trash,
            [IconName.SHIELD_CHECK]: Icon.ShieldCheck,
            [IconName.RECEIPT]: Icon.Receipt,
            [IconName.LINKEDIN]: Icon.Linkedin,
            [IconName.EMAIL]: Icon.Email,
            [IconName.CALL]: Icon.Call,
            [IconName.SWITCH]: Icon.Switch,
            [IconName.CALENDAR_CHECK]: Icon.CalendarCheck,
            [IconName.USER]: Icon.User,
            [IconName.LINK]: Icon.Link,
            [IconName.WARNING]: Icon.Warning,
            [IconName.MESSAGE]: Icon.Message,
            [IconName.THUMBS_DOWN]: Icon.ThumbsDown,
            [IconName.THUMBS_UP]: Icon.ThumbsUp,
            [IconName.LIGHTBULB]: Icon.Lightbulb,
            [IconName.ARROW_UP]: Icon.ArrowUp,
            [IconName.ARROW_DOWN]: Icon.ArrowDown,
            [IconName.FAVORITE]: Icon.Favorite,
            [IconName.ARROW_LEAVE]: Icon.ArrowLeave,
            [IconName.CHEVRON_LEFT]: Icon.ChevronLeft,
            [IconName.CHEVRON_RIGHT]: Icon.ChevronRight,
            [IconName.CONTACT_BOOK]: Icon.ContactBook,
            [IconName.HEART]: Icon.Heart,
            [IconName.CLOCK]: Icon.Clock,
            [IconName.ARROW_LEFT]: Icon.ArrowLeft,
            [IconName.BARS]: Icon.Bars,
            [IconName.DOWNLOAD]: Icon.Download,
            [IconName.CHECKLIST]: Icon.Checklist,
            [IconName.USER_CHECK]: Icon.UserCheck,
            [IconName.SHARE]: Icon.Share,
        }[name];
        if (!icon) {
            console.error(`Icon ${name} not found`);
            return Icon.CircleQuestion;
        }
        return icon;
    }, [name]);
    return icon;
};
